<template>
    <div class="">
        <ctlHomeNav></ctlHomeNav>
        <v-layout>
            <v-flex xs12 class="text-xs-center">
                <v-btn large @click.prevent="$router.push({ name: 'zips-assign-map' })" class="secondary" >Start a Territory Assignment</v-btn>
            </v-flex>

        </v-layout>
        <v-container fluid >
            <v-layout align-start>
                <v-flex xs12>
                    <v-card class="elevation-12">

                    <v-card-text v-if="savedMaps">
                        <v-data-table
                            v-bind:headers="mapsHeaders"
                            :items="savedMaps"
                            hide-actions
                            class="elevation-1"
                            >
                            <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.name }}</td>
                            <td class="text-xs-left">{{ props.item.updateBy }}</td>
                            <td class="text-xs-left">{{ props.item.updateDate }}</td>
                            <td class="text-xs-left">
                                <v-btn color="primary" small href="#" 
                                @click.prevent="viewMap(props.item.id)">Open</v-btn>
                                <v-btn color="warning" small href="#" 
                                @click.prevent="deleteMap(props.item)">Delete</v-btn>
                            </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-layout row>
                            <v-alert value="true" color="warning" body-2 outline>No Record Found</v-alert>
                        </v-layout>
                    </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!-- {{userData}} -->
    </div>


</template>
<script>
import ctlHomeNav from '@/components/ctlHomeNav'
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    components: {
        'ctlHomeNav': ctlHomeNav
        },
    data: () => ({
        savedMaps: [],
        mapsHeaders: [
            {text: 'Name', sortable: false, value: 'name'},
            {text: 'Update By', sortable: false, value: 'updateBy'},
            {text: 'Update Date', sortable: false, value: 'updateDate'},
            {text: '', sortable: false, value: 'id'},
        ],
    }),
    computed: {

    },
    watch: {
    },
    methods: {
        ...mapActions('tazApi',[
            'getSavedMaps',
            'saveSavedMap'
        ]),
        async deleteMap(mapData) {
            if(!confirm('Are you sure to delete?')) {
                return
            }
            mapData.active = false
            await this.saveSavedMap(mapData)
            this.getMaps()
        },
        async getMaps () {
            this.savedMaps = await this.getSavedMaps()
        },
        viewMap: function (id) {
            this.$router.push({ name: 'zips-assign-map-saved', params: { id: id } })
        },
        newQuote: function () {
            // console.log('open pub-quote-new')
            this.$router.push({ name: 'pub-quote-new' })
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {
        this.getMaps()
    },
    mounted: function () {

    },

    destroyed: function () {
        this.onDismissed()
    }
}
</script>